import { HelpTopicDefinition, HelpTopicId } from '../models/help.model';

export const HELP_TOPICS: Record<HelpTopicId, HelpTopicDefinition> = {
  dashboard: {
    titleKey: 'helpDashboardTitle',
    introKey: 'helpDashboardIntro',
    icons: [
      { icon: 'users', titleKey: 'helpDashboardIcon1Title', descKey: 'helpDashboardIcon1Desc' },
      { icon: 'arrow-down-circle', titleKey: 'helpDashboardIcon2Title', descKey: 'helpDashboardIcon2Desc' },
      { icon: 'arrow-up-circle', titleKey: 'helpDashboardIcon3Title', descKey: 'helpDashboardIcon3Desc' },
      { icon: 'trending-up', titleKey: 'helpDashboardIcon4Title', descKey: 'helpDashboardIcon4Desc' },
      { icon: 'trending-down', titleKey: 'helpDashboardIcon5Title', descKey: 'helpDashboardIcon5Desc' },
      { icon: 'activity', titleKey: 'helpDashboardIcon6Title', descKey: 'helpDashboardIcon6Desc' },
      { icon: 'clock', titleKey: 'helpDashboardIcon7Title', descKey: 'helpDashboardIcon7Desc' },
      { icon: 'list', titleKey: 'helpDashboardIcon8Title', descKey: 'helpDashboardIcon8Desc' },
      { icon: 'zap', titleKey: 'helpDashboardIcon10Title', descKey: 'helpDashboardIcon10Desc' },
      { icon: 'message-circle', titleKey: 'helpDashboardIcon9Title', descKey: 'helpDashboardIcon9Desc' }
    ]
  },
  ledger: {
    titleKey: 'helpLedgerTitle',
    introKey: 'helpLedgerIntro',
    icons: [
      { icon: 'users', titleKey: 'helpLedgerIcon1Title', descKey: 'helpLedgerIcon1Desc' },
      { icon: 'user-plus', titleKey: 'helpLedgerIcon2Title', descKey: 'helpLedgerIcon2Desc' },
      { icon: 'search', titleKey: 'helpLedgerIcon3Title', descKey: 'helpLedgerIcon3Desc' },
      { icon: 'message-circle', titleKey: 'helpLedgerIcon4Title', descKey: 'helpLedgerIcon4Desc' },
      { icon: 'more-vertical', titleKey: 'helpLedgerIcon5Title', descKey: 'helpLedgerIcon5Desc' },
      { icon: 'briefcase', titleKey: 'helpLedgerIcon13Title', descKey: 'helpLedgerIcon13Desc' },
      { icon: 'zap', titleKey: 'helpLedgerIcon6Title', descKey: 'helpLedgerIcon6Desc' },
      { icon: 'user', titleKey: 'helpLedgerIcon7Title', descKey: 'helpLedgerIcon7Desc' },
      { icon: 'check-circle', titleKey: 'helpLedgerIcon8Title', descKey: 'helpLedgerIcon8Desc' },
      { icon: 'x-circle', titleKey: 'helpLedgerIcon9Title', descKey: 'helpLedgerIcon9Desc' },
      { icon: 'calendar', titleKey: 'helpLedgerIcon10Title', descKey: 'helpLedgerIcon10Desc' },
      { icon: 'bell', titleKey: 'helpLedgerIcon11Title', descKey: 'helpLedgerIcon11Desc' },
      { icon: 'filter', titleKey: 'helpLedgerIcon12Title', descKey: 'helpLedgerIcon12Desc' },
      { icon: 'phone', titleKey: 'helpLedgerIcon14Title', descKey: 'helpLedgerIcon14Desc' }
    ]
  },
  ledgerCustomerList: {
    titleKey: 'helpLedgerListTitle',
    introKey: 'helpLedgerListIntro',
    icons: [
      { icon: 'users', titleKey: 'helpLedgerListIcon1Title', descKey: 'helpLedgerListIcon1Desc' },
      { icon: 'user-plus', titleKey: 'helpLedgerListIcon2Title', descKey: 'helpLedgerListIcon2Desc' },
      { icon: 'search', titleKey: 'helpLedgerListIcon3Title', descKey: 'helpLedgerListIcon3Desc' },
      { icon: 'filter', titleKey: 'helpLedgerListIcon4Title', descKey: 'helpLedgerListIcon4Desc' },
      { icon: 'user-check', titleKey: 'helpLedgerListIcon10Title', descKey: 'helpLedgerListIcon10Desc' },
      { icon: 'copy', titleKey: 'helpLedgerListIcon11Title', descKey: 'helpLedgerListIcon11Desc' },
      { icon: 'check-square', titleKey: 'helpLedgerListIcon12Title', descKey: 'helpLedgerListIcon12Desc' },
      { icon: 'folder-plus', titleKey: 'helpLedgerListIcon13Title', descKey: 'helpLedgerListIcon13Desc' },
      { icon: 'pie-chart', titleKey: 'helpLedgerListIcon5Title', descKey: 'helpLedgerListIcon5Desc' },
      { icon: 'trending-up', titleKey: 'helpLedgerListIcon6Title', descKey: 'helpLedgerListIcon6Desc' },
      { icon: 'trending-down', titleKey: 'helpLedgerListIcon7Title', descKey: 'helpLedgerListIcon7Desc' },
      { icon: 'activity', titleKey: 'helpLedgerListIcon8Title', descKey: 'helpLedgerListIcon8Desc' },
      { icon: 'bell', titleKey: 'helpLedgerListIcon9Title', descKey: 'helpLedgerListIcon9Desc' }
    ]
  },
  ledgerChat: {
    titleKey: 'helpLedgerChatTitle',
    introKey: 'helpLedgerChatIntro',
    icons: [
      { icon: 'user', titleKey: 'helpLedgerChatIcon1Title', descKey: 'helpLedgerChatIcon1Desc' },
      { icon: 'search', titleKey: 'helpLedgerChatIconFilterTitle', descKey: 'helpLedgerChatIconFilterDesc' },
      { icon: 'more-vertical', titleKey: 'helpLedgerChatIcon2Title', descKey: 'helpLedgerChatIcon2Desc' },
      { icon: 'user-x', titleKey: 'helpLedgerChatIcon13Title', descKey: 'helpLedgerChatIcon13Desc' },
      { icon: 'message-circle', titleKey: 'helpLedgerChatIcon3Title', descKey: 'helpLedgerChatIcon3Desc' },
      { icon: 'arrow-down-circle', titleKey: 'helpLedgerChatIcon4Title', descKey: 'helpLedgerChatIcon4Desc' },
      { icon: 'arrow-up-circle', titleKey: 'helpLedgerChatIcon5Title', descKey: 'helpLedgerChatIcon5Desc' },
      { icon: 'zap', titleKey: 'helpLedgerChatIcon6Title', descKey: 'helpLedgerChatIcon6Desc' },
      { icon: 'check-circle', titleKey: 'helpLedgerChatIcon7Title', descKey: 'helpLedgerChatIcon7Desc' },
      { icon: 'x-circle', titleKey: 'helpLedgerChatIcon8Title', descKey: 'helpLedgerChatIcon8Desc' },
      { icon: 'calendar', titleKey: 'helpLedgerChatIcon9Title', descKey: 'helpLedgerChatIcon9Desc' },
      { icon: 'bell', titleKey: 'helpLedgerChatIcon10Title', descKey: 'helpLedgerChatIcon10Desc' },
      { icon: 'briefcase', titleKey: 'helpLedgerChatIcon11Title', descKey: 'helpLedgerChatIcon11Desc' },
      { icon: 'phone', titleKey: 'helpLedgerChatIcon12Title', descKey: 'helpLedgerChatIcon12Desc' }
    ]
  },
  pendingTransactions: {
    titleKey: 'helpPendingTransactionsTitle',
    introKey: 'helpPendingTransactionsIntro',
    icons: [
      { icon: 'search', titleKey: 'helpPendingTransactionsIcon1Title', descKey: 'helpPendingTransactionsIcon1Desc' },
      { icon: 'users', titleKey: 'helpPendingTransactionsIcon2Title', descKey: 'helpPendingTransactionsIcon2Desc' },
      { icon: 'check-circle', titleKey: 'helpPendingTransactionsIcon3Title', descKey: 'helpPendingTransactionsIcon3Desc' },
      { icon: 'x-circle', titleKey: 'helpPendingTransactionsIcon4Title', descKey: 'helpPendingTransactionsIcon4Desc' },
      { icon: 'more-vertical', titleKey: 'helpPendingTransactionsIcon5Title', descKey: 'helpPendingTransactionsIcon5Desc' },
      { icon: 'message-circle', titleKey: 'helpPendingTransactionsIcon6Title', descKey: 'helpPendingTransactionsIcon6Desc' }
    ]
  },
  pendingTransactionsDialog: {
    titleKey: 'helpPendingTransactionsDialogTitle',
    introKey: 'helpPendingTransactionsDialogIntro',
    icons: [
      { icon: 'dollar-sign', titleKey: 'helpPendingTransactionsDialogIcon1Title', descKey: 'helpPendingTransactionsDialogIcon1Desc' },
      { icon: 'check-square', titleKey: 'helpPendingTransactionsDialogIcon2Title', descKey: 'helpPendingTransactionsDialogIcon2Desc' },
      { icon: 'x-square', titleKey: 'helpPendingTransactionsDialogIcon3Title', descKey: 'helpPendingTransactionsDialogIcon3Desc' },
      { icon: 'repeat', titleKey: 'helpPendingTransactionsDialogIcon4Title', descKey: 'helpPendingTransactionsDialogIcon4Desc' }
    ]
  },
  transferGroup: {
    titleKey: 'helpTransferGroupTitle',
    introKey: 'helpTransferGroupIntro',
    icons: [
      { icon: 'briefcase', titleKey: 'helpTransferGroupIcon1Title', descKey: 'helpTransferGroupIcon1Desc' },
      { icon: 'folder', titleKey: 'helpTransferGroupIcon2Title', descKey: 'helpTransferGroupIcon2Desc' },
      { icon: 'users', titleKey: 'helpTransferGroupIcon3Title', descKey: 'helpTransferGroupIcon3Desc' },
      { icon: 'alert-triangle', titleKey: 'helpTransferGroupIcon4Title', descKey: 'helpTransferGroupIcon4Desc' },
      { icon: 'check-circle', titleKey: 'helpTransferGroupIcon5Title', descKey: 'helpTransferGroupIcon5Desc' },
      { icon: 'x-circle', titleKey: 'helpTransferGroupIcon6Title', descKey: 'helpTransferGroupIcon6Desc' }
    ]
  },
  aiChat: {
    titleKey: 'helpAiChatTitle',
    introKey: 'helpAiChatIntro',
    icons: [
      { icon: 'message-square', titleKey: 'helpAiChatIcon1Title', descKey: 'helpAiChatIcon1Desc' },
      { icon: 'zap', titleKey: 'helpAiChatIcon2Title', descKey: 'helpAiChatIcon2Desc' },
      { icon: 'mic', titleKey: 'helpAiChatIcon3Title', descKey: 'helpAiChatIcon3Desc' }
    ]
  },
  landing: {
    titleKey: 'helpLandingTitle',
    introKey: 'helpLandingIntro',
    icons: [
      { icon: 'users', titleKey: 'helpLandingIcon1Title', descKey: 'helpLandingIcon1Desc' },
      { icon: 'shield', titleKey: 'helpLandingIcon2Title', descKey: 'helpLandingIcon2Desc' },
      { icon: 'clock', titleKey: 'helpLandingIcon3Title', descKey: 'helpLandingIcon3Desc' }
    ]
  },
  recycleBin: {
    titleKey: 'helpRecycleBinTitle',
    introKey: 'helpRecycleBinIntro',
    icons: [
      { icon: 'trash-2', titleKey: 'helpRecycleBinIcon1Title', descKey: 'helpRecycleBinIcon1Desc' },
      { icon: 'filter', titleKey: 'helpRecycleBinIcon2Title', descKey: 'helpRecycleBinIcon2Desc' },
      { icon: 'rotate-ccw', titleKey: 'helpRecycleBinIcon3Title', descKey: 'helpRecycleBinIcon3Desc' }
    ]
  },
  followupList: {
    titleKey: 'helpFollowupListTitle',
    introKey: 'helpFollowupListIntro',
    icons: [
      { icon: 'calendar', titleKey: 'helpFollowupListIcon1Title', descKey: 'helpFollowupListIcon1Desc' },
      { icon: 'filter', titleKey: 'helpFollowupListIcon2Title', descKey: 'helpFollowupListIcon2Desc' },
      { icon: 'users', titleKey: 'helpFollowupListIcon3Title', descKey: 'helpFollowupListIcon3Desc' },
      { icon: 'edit-2', titleKey: 'helpFollowupListIcon4Title', descKey: 'helpFollowupListIcon4Desc' },
      { icon: 'message-square', titleKey: 'helpFollowupListIcon5Title', descKey: 'helpFollowupListIcon5Desc' },
      { icon: 'check-square', titleKey: 'helpFollowupListIcon6Title', descKey: 'helpFollowupListIcon6Desc' },
      { icon: 'check-circle', titleKey: 'helpFollowupListIcon7Title', descKey: 'helpFollowupListIcon7Desc' }
    ]
  },
  recurringFollowupList: {
    titleKey: 'helpRecurringFollowupListTitle',
    introKey: 'helpRecurringFollowupListIntro',
    icons: [
      { icon: 'repeat', titleKey: 'helpRecurringFollowupListIcon1Title', descKey: 'helpRecurringFollowupListIcon1Desc' },
      { icon: 'filter', titleKey: 'helpRecurringFollowupListIcon2Title', descKey: 'helpRecurringFollowupListIcon2Desc' },
      { icon: 'tag', titleKey: 'helpRecurringFollowupListIcon3Title', descKey: 'helpRecurringFollowupListIcon3Desc' },
      { icon: 'check-circle', titleKey: 'helpRecurringFollowupListIcon4Title', descKey: 'helpRecurringFollowupListIcon4Desc' },
      { icon: 'square', titleKey: 'helpRecurringFollowupListIcon5Title', descKey: 'helpRecurringFollowupListIcon5Desc' },
      { icon: 'skip-forward', titleKey: 'helpRecurringFollowupListIcon6Title', descKey: 'helpRecurringFollowupListIcon6Desc' },
      { icon: 'list', titleKey: 'helpRecurringFollowupListIcon7Title', descKey: 'helpRecurringFollowupListIcon7Desc' }
    ]
  },
  customerStatement: {
    titleKey: 'helpCustomerStatementTitle',
    introKey: 'helpCustomerStatementIntro',
    icons: [
      { icon: 'file-text', titleKey: 'helpCustomerStatementIcon1Title', descKey: 'helpCustomerStatementIcon1Desc' },
      { icon: 'calendar', titleKey: 'helpCustomerStatementIcon2Title', descKey: 'helpCustomerStatementIcon2Desc' },
      { icon: 'pie-chart', titleKey: 'helpCustomerStatementIcon3Title', descKey: 'helpCustomerStatementIcon3Desc' },
      { icon: 'download', titleKey: 'helpCustomerStatementIcon4Title', descKey: 'helpCustomerStatementIcon4Desc' },
      { icon: 'share-2', titleKey: 'helpCustomerStatementIcon5Title', descKey: 'helpCustomerStatementIcon5Desc' },
      { icon: 'arrow-left', titleKey: 'helpCustomerStatementIcon6Title', descKey: 'helpCustomerStatementIcon6Desc' }
    ]
  },
  commonStatement: {
    titleKey: 'helpCommonStatementTitle',
    introKey: 'helpCommonStatementIntro',
    icons: [
      { icon: 'file-text', titleKey: 'helpCommonStatementIcon1Title', descKey: 'helpCommonStatementIcon1Desc' },
      { icon: 'calendar', titleKey: 'helpCommonStatementIcon2Title', descKey: 'helpCommonStatementIcon2Desc' },
      { icon: 'pie-chart', titleKey: 'helpCommonStatementIcon3Title', descKey: 'helpCommonStatementIcon3Desc' },
      { icon: 'download', titleKey: 'helpCommonStatementIcon4Title', descKey: 'helpCommonStatementIcon4Desc' },
      { icon: 'share-2', titleKey: 'helpCommonStatementIcon5Title', descKey: 'helpCommonStatementIcon5Desc' },
      { icon: 'users', titleKey: 'helpCommonStatementIcon6Title', descKey: 'helpCommonStatementIcon6Desc' }
    ]
  },
  login: {
    titleKey: 'helpLoginTitle',
    introKey: 'helpLoginIntro',
    icons: [
      { icon: 'smartphone', titleKey: 'helpLoginIcon1Title', descKey: 'helpLoginIcon1Desc' },
      { icon: 'lock', titleKey: 'helpLoginIcon2Title', descKey: 'helpLoginIcon2Desc' },
      { icon: 'globe', titleKey: 'helpLoginIcon3Title', descKey: 'helpLoginIcon3Desc' }
    ]
  },
  businessSetup: {
    titleKey: 'helpBusinessSetupTitle',
    introKey: 'helpBusinessSetupIntro',
    icons: [
      { icon: 'home', titleKey: 'helpBusinessSetupIcon1Title', descKey: 'helpBusinessSetupIcon1Desc' },
      { icon: 'save', titleKey: 'helpBusinessSetupIcon2Title', descKey: 'helpBusinessSetupIcon2Desc' }
    ]
  },
  entryCreate: {
    titleKey: 'helpEntryCreateTitle',
    introKey: 'helpEntryCreateIntro',
    icons: [
      { icon: 'dollar-sign', titleKey: 'helpEntryCreateIcon1Title', descKey: 'helpEntryCreateIcon1Desc' },
      { icon: 'mic', titleKey: 'helpEntryCreateIcon2Title', descKey: 'helpEntryCreateIcon2Desc' },
      { icon: 'paperclip', titleKey: 'helpEntryCreateIcon3Title', descKey: 'helpEntryCreateIcon3Desc' },
      { icon: 'calendar', titleKey: 'helpEntryCreateIcon4Title', descKey: 'helpEntryCreateIcon4Desc' },
      { icon: 'zap', titleKey: 'helpEntryCreateIcon5Title', descKey: 'helpEntryCreateIcon5Desc' },
      { icon: 'bell', titleKey: 'helpEntryCreateIcon6Title', descKey: 'helpEntryCreateIcon6Desc' },
      { icon: 'repeat', titleKey: 'helpEntryCreateIcon7Title', descKey: 'helpEntryCreateIcon7Desc' }
    ]
  },
  entryFollowUp: {
    titleKey: 'helpEntryFollowUpTitle',
    introKey: 'helpEntryFollowUpIntro',
    icons: [
      { icon: 'bell', titleKey: 'helpEntryFollowUpIcon1Title', descKey: 'helpEntryFollowUpIcon1Desc' },
      { icon: 'calendar', titleKey: 'helpEntryFollowUpIcon2Title', descKey: 'helpEntryFollowUpIcon2Desc' },
      { icon: 'clock', titleKey: 'helpEntryFollowUpIcon5Title', descKey: 'helpEntryFollowUpIcon5Desc' },
      { icon: 'list', titleKey: 'helpEntryFollowUpIcon6Title', descKey: 'helpEntryFollowUpIcon6Desc' }
    ]
  },
  entryRecurringPayment: {
    titleKey: 'helpEntryRecurringPaymentTitle',
    introKey: 'helpEntryRecurringPaymentIntro',
    icons: [
      { icon: 'repeat', titleKey: 'helpEntryRecurringPaymentIcon1Title', descKey: 'helpEntryRecurringPaymentIcon1Desc' },
      { icon: 'tag', titleKey: 'helpEntryRecurringPaymentIcon2Title', descKey: 'helpEntryRecurringPaymentIcon2Desc' },
      { icon: 'clock', titleKey: 'helpEntryRecurringPaymentIcon3Title', descKey: 'helpEntryRecurringPaymentIcon3Desc' },
      { icon: 'bell', titleKey: 'helpEntryRecurringPaymentIcon4Title', descKey: 'helpEntryRecurringPaymentIcon4Desc' },
      { icon: 'calendar', titleKey: 'helpEntryRecurringPaymentIcon5Title', descKey: 'helpEntryRecurringPaymentIcon5Desc' },
      { icon: 'list', titleKey: 'helpEntryRecurringPaymentIcon6Title', descKey: 'helpEntryRecurringPaymentIcon6Desc' }
    ]
  },
  entryEdit: {
    titleKey: 'helpEntryEditTitle',
    introKey: 'helpEntryEditIntro',
    icons: [
      { icon: 'edit-2', titleKey: 'helpEntryEditIcon1Title', descKey: 'helpEntryEditIcon1Desc' },
      { icon: 'image', titleKey: 'helpEntryEditIcon2Title', descKey: 'helpEntryEditIcon2Desc' },
      { icon: 'clock', titleKey: 'helpEntryEditIcon3Title', descKey: 'helpEntryEditIcon3Desc' },
      { icon: 'trash-2', titleKey: 'helpEntryEditIcon4Title', descKey: 'helpEntryEditIcon4Desc' },
      { icon: 'bell', titleKey: 'helpEntryEditIcon5Title', descKey: 'helpEntryEditIcon5Desc' },
      { icon: 'message-circle', titleKey: 'helpEntryEditIcon6Title', descKey: 'helpEntryEditIcon6Desc' }
    ]
  },
  followupDialog: {
    titleKey: 'helpFollowupDialogTitle',
    introKey: 'helpFollowupDialogIntro',
    icons: [
      { icon: 'clipboard', titleKey: 'helpFollowupDialogIcon1Title', descKey: 'helpFollowupDialogIcon1Desc' },
      { icon: 'calendar', titleKey: 'helpFollowupDialogIcon2Title', descKey: 'helpFollowupDialogIcon2Desc' },
      { icon: 'check-circle', titleKey: 'helpFollowupDialogIcon3Title', descKey: 'helpFollowupDialogIcon3Desc' },
      { icon: 'dollar-sign', titleKey: 'helpFollowupDialogIcon4Title', descKey: 'helpFollowupDialogIcon4Desc' },
      { icon: 'bell', titleKey: 'helpFollowupDialogIcon5Title', descKey: 'helpFollowupDialogIcon5Desc' }
    ]
  },
  recurringFollowupDialog: {
    titleKey: 'helpRecurringFollowupDialogTitle',
    introKey: 'helpRecurringFollowupDialogIntro',
    icons: [
      { icon: 'clipboard', titleKey: 'helpRecurringFollowupDialogIcon1Title', descKey: 'helpRecurringFollowupDialogIcon1Desc' },
      { icon: 'tag', titleKey: 'helpRecurringFollowupDialogIcon2Title', descKey: 'helpRecurringFollowupDialogIcon2Desc' },
      { icon: 'clock', titleKey: 'helpRecurringFollowupDialogIcon3Title', descKey: 'helpRecurringFollowupDialogIcon3Desc' },
      { icon: 'bell', titleKey: 'helpRecurringFollowupDialogIcon4Title', descKey: 'helpRecurringFollowupDialogIcon4Desc' },
      { icon: 'calendar', titleKey: 'helpRecurringFollowupDialogIcon5Title', descKey: 'helpRecurringFollowupDialogIcon5Desc' },
      { icon: 'save', titleKey: 'helpRecurringFollowupDialogIcon6Title', descKey: 'helpRecurringFollowupDialogIcon6Desc' }
    ]
  },
  customerProfile: {
    titleKey: 'helpCustomerProfileTitle',
    introKey: 'helpCustomerProfileIntro',
    icons: [
      { icon: 'user', titleKey: 'helpCustomerProfileIcon1Title', descKey: 'helpCustomerProfileIcon1Desc' },
      { icon: 'camera', titleKey: 'helpCustomerProfileIcon2Title', descKey: 'helpCustomerProfileIcon2Desc' },
      { icon: 'save', titleKey: 'helpCustomerProfileIcon3Title', descKey: 'helpCustomerProfileIcon3Desc' },
      { icon: 'trash-2', titleKey: 'helpCustomerProfileIcon4Title', descKey: 'helpCustomerProfileIcon4Desc' },
      { icon: 'bell', titleKey: 'helpCustomerProfileIcon5Title', descKey: 'helpCustomerProfileIcon5Desc' }
    ]
  },
  userProfile: {
    titleKey: 'helpUserProfileTitle',
    introKey: 'helpUserProfileIntro',
    icons: [
      { icon: 'briefcase', titleKey: 'helpUserProfileIcon1Title', descKey: 'helpUserProfileIcon1Desc' },
      { icon: 'smartphone', titleKey: 'helpUserProfileIcon2Title', descKey: 'helpUserProfileIcon2Desc' },
      { icon: 'camera', titleKey: 'helpUserProfileIcon3Title', descKey: 'helpUserProfileIcon3Desc' },
      { icon: 'save', titleKey: 'helpUserProfileIcon4Title', descKey: 'helpUserProfileIcon4Desc' }
    ]
  },
  addCustomer: {
    titleKey: 'helpAddCustomerTitle',
    introKey: 'helpAddCustomerIntro',
    icons: [
      { icon: 'user-plus', titleKey: 'helpAddCustomerIcon1Title', descKey: 'helpAddCustomerIcon1Desc' },
      { icon: 'smartphone', titleKey: 'helpAddCustomerIcon2Title', descKey: 'helpAddCustomerIcon2Desc' },
      { icon: 'zap', titleKey: 'helpAddCustomerIcon3Title', descKey: 'helpAddCustomerIcon3Desc' }
    ]
  },
  aiVoice: {
    titleKey: 'helpAiVoiceTitle',
    introKey: 'helpAiVoiceIntro',
    icons: [
      { icon: 'mic', titleKey: 'helpAiVoiceIcon1Title', descKey: 'helpAiVoiceIcon1Desc' },
      { icon: 'zap', titleKey: 'helpAiVoiceIcon2Title', descKey: 'helpAiVoiceIcon2Desc' },
      { icon: 'check', titleKey: 'helpAiVoiceIcon3Title', descKey: 'helpAiVoiceIcon3Desc' },
      { icon: 'info', titleKey: 'helpAiVoiceIcon4Title', descKey: 'helpAiVoiceIcon4Desc' }
    ]
  },
  businessPopup: {
    titleKey: 'helpBusinessPopupTitle',
    introKey: 'helpBusinessPopupIntro',
    icons: [
      { icon: 'home', titleKey: 'helpBusinessPopupIcon1Title', descKey: 'helpBusinessPopupIcon1Desc' },
      { icon: 'edit-2', titleKey: 'helpBusinessPopupIcon2Title', descKey: 'helpBusinessPopupIcon2Desc' },
      { icon: 'plus-circle', titleKey: 'helpBusinessPopupIcon3Title', descKey: 'helpBusinessPopupIcon3Desc' }
    ]
  },
  settings: {
    titleKey: 'helpSettingsTitle',
    introKey: 'helpSettingsIntro',
    icons: [
      { icon: 'help-circle', titleKey: 'helpSettingsIcon1Title', descKey: 'helpSettingsIcon1Desc' },
      { icon: 'globe', titleKey: 'helpSettingsIcon2Title', descKey: 'helpSettingsIcon2Desc' },
      { icon: 'save', titleKey: 'helpSettingsIcon3Title', descKey: 'helpSettingsIcon3Desc' },
      { icon: 'lock', titleKey: 'helpSettingsIcon4Title', descKey: 'helpSettingsIcon4Desc' },
      { icon: 'bell', titleKey: 'helpSettingsIcon5Title', descKey: 'helpSettingsIcon5Desc' }
    ]
  }
};
